import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Eye, Lock } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Panel, SectionLabel, StatusBadge } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";

// VEDERE -> CAPIRE -> AGIRE: che documento è, processo, origine, revisione, visibilità, prossima azione
export const DocumentContext = ({ d, onDone }) => {
  const c = d.context;
  const origin = d.linked.find((x) => x.role === "origine");
  const safe = c.visibility === "customer_safe";
  const toggle = async () => {
    try { await api.put(`/documents/${d.id}/visibility`, { visibility: safe ? "interna" : "customer_safe" }); toast.success(safe ? "Documento reso Interno" : "Documento reso Customer-safe"); onDone(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <Panel className="mb-6 p-5" data-testid="document-context">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <div><SectionLabel>Processo</SectionLabel><p className="mt-1 text-sm font-semibold text-ink" data-testid="document-context-process">{c.process}</p>
          <p className="text-xs text-slate-500">{d.category_label}{d.ddt ? ` · DDT ${d.ddt.number}` : ""}</p></div>
        <div><SectionLabel>Origine</SectionLabel><p className="mt-1 text-sm text-ink" data-testid="document-context-origin">{origin ? origin.label : d.auto ? "Generato dal sistema" : "Caricato manualmente"}</p>
          {c.revision && <p className="text-xs text-slate-500" data-testid="document-context-revision">Rev. {c.revision.revision} · {c.revision.status_label}
            {!c.revision.is_current && <> · <Link className="text-brand-600 hover:underline" to={`/offerte/${c.revision.latest_id}`}>vai alla rev. {c.revision.latest_revision}</Link></>}</p>}</div>
        <div><SectionLabel>Visibilità</SectionLabel>
          <div className="mt-1 flex items-center gap-2" data-testid="document-context-visibility">
            <StatusBadge tone={safe ? "green" : "neutral"}>{safe ? <Eye className="mr-1 inline h-3 w-3" /> : <Lock className="mr-1 inline h-3 w-3" />}{c.visibility_label}</StatusBadge>
            {d.can.visibility && <Button size="sm" variant="ghost" onClick={toggle} data-testid="document-visibility-toggle">{safe ? "Rendi interno" : "Rendi customer-safe"}</Button>}</div></div>
        <div><SectionLabel>Prossima azione</SectionLabel>
          <p className="mt-1 flex items-start gap-1.5 text-sm text-ink" data-testid="document-context-next"><ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" />{c.next_action || "Nessuna azione richiesta."}</p></div>
      </div>
    </Panel>
  );
};
